import agent from '../agent'
import {
  FETCH_FOLLOWING_FINISHED,
  FETCH_FOLLOWING_STARTED,
  FETCH_USER_FOLLOW_FINISHED,
  FETCH_USER_FOLLOW_STARTED,
  FOLLOW_USER,
  UNFOLLOW_USER
} from "../constants/actionTypes"
import {message} from "antd";
import {getLabel} from "../../src/language";

export const fetchFollowingFinished = (payload) => ({
  type: FETCH_FOLLOWING_FINISHED,
  payload
})

export const fetchFollowingsStart = () => ({
  type: FETCH_FOLLOWING_STARTED
})

export const fetchUserFollowFinished = (payload) => ({
  type: FETCH_USER_FOLLOW_FINISHED,
  payload
})

export const fetchUserFollowStart = () => ({
  type: FETCH_USER_FOLLOW_STARTED
})


export const fetchFollowings = (dispatch) => (userId) => {
  dispatch(fetchFollowingsStart());
  agent.Profile.followees(userId).then(res => {
    dispatch(fetchFollowingFinished(res));
  }, err => {
    dispatch(fetchFollowingFinished(err));
  })
}

export const fetchFollowesByUserId = (dispatch) => (userId) => {
  dispatch(fetchUserFollowStart());
  agent.Profile.followeesByUserId(userId).then(res => {
    dispatch(fetchUserFollowFinished(res));
  }, err => {
    dispatch(fetchUserFollowFinished(err));
  })
}

export const followUser = () => ({
  type: FOLLOW_USER,
  isSuccess: true
})

export const unFollowUser = () => ({
  type: UNFOLLOW_USER,
  isUnfollowed: true
})


export const onFollow = (dispatch, getState) => (userId, followeeId, followeeType, followLevel, cb) => {
  const store = getState();
  let currentUserId = store.common.currentUser ? store.common.currentUser.id : null;
  agent.Profile.follow(userId, followeeId, followeeType, followLevel).then(res => {
    dispatch(followUser(res));
    if(!cb) {
      fetchFollowings(dispatch)(currentUserId)
    } else {
      cb(res)
    }
  }, err => {
    let errorMessage = getLabel(482)
    message.error(errorMessage)
    dispatch(followUser(err));
  })
}

export const onUnFollow = (dispatch, getState) => (followeeId, followeeType, cb) => {
  const store = getState();
  let currentUserId = store.common.currentUser ? store.common.currentUser.id : null;
  agent.Profile.unfollow(followeeId, followeeType).then(res => {
    dispatch(unFollowUser(res));
    if(!cb) {
      fetchFollowings(dispatch)(currentUserId)
    } else {
      cb(res)
    }
  }, err => {
    dispatch(unFollowUser(err));
  })
}
